import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df7b386"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("h1", null, " µDex ")
], -1))

import DarkThemeSwitch from '@/components/UI/DarkThemeSwitch'
import Latex from '@/components/Latex/LatexLogo.vue'
import store from '@/store'
import { computed } from 'vue'


export default {
  __name: 'NavComponent',
  setup(__props) {

const isLogged = computed(() => store.isLogged)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode(" Database ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/papers" }, {
          default: _withCtx(() => [
            _createTextVNode(" Papers ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/to_latex" }, {
          default: _withCtx(() => [
            _createVNode(Latex)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/to_word" }, {
          default: _withCtx(() => [
            _createTextVNode(" Word ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        false
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/statistics"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Statistics ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/reader" }, {
          default: _withCtx(() => [
            _createTextVNode(" Viz ")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_1,
    _createElementVNode("span", null, [
      _createVNode(_component_router_link, { to: "/lesson" }, {
        default: _withCtx(() => [
          _createTextVNode(" Lesson ")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/contact" }, {
        default: _withCtx(() => [
          _createTextVNode(" Contact ")
        ]),
        _: 1
      }),
      (_unref(isLogged))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/admin"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Admin ")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/login"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Login ")
            ]),
            _: 1
          })),
      _createVNode(_unref(DarkThemeSwitch))
    ])
  ]))
}
}

}